import React from "react";
import "./BPOSupport.css";

const BPOSupport = () => {
  return (
    <div>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
      <p>Thi is BPOSupport</p>
    </div>
  );
};

export default BPOSupport;
